import * as React from 'react';
import { ColumnProvider } from 'owa-calendar-surface-dategrid';
import { observer } from 'mobx-react';
import TimeMarkerBaseBehavior from './TimeMarkerBaseBehavior';

const styles = require('./TimeMarker.scss');

/**
 * Component that shows a line in the position of the current time on the calendar day and week views
 */
export default observer(function TimeMarkerTodayBehavior({
    columnProvider,
}: {
    columnProvider: ColumnProvider;
}) {
    return (
        <TimeMarkerBaseBehavior
            columnProvider={columnProvider}
            className={styles.currentDayMarker}
            zIndex={2}
        />
    );
});
